import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsElixirComponent } from './simple-icons-elixir.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsElixirComponent ],
    exports:      [ SimpleIconsElixirComponent ],
    bootstrap:    []
})
export class SimpleIconsElixirModule {}
